import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

class Pricing extends Component {
  renderTeamName(){
    if(this.props.team){
      if(this.props.team.company && this.props.team.company !== ""){
        return this.props.team.company;
      }else{
        return this.props.team.firstname+" "+this.props.team.lastname;
      }
    }
    return "";
  }
  renderPlans(){
    if(this.props.plans_loading != true && this.props.plans.length > 0){
      return(
        <div >
          {
            this.props.plans.map((plan) =>{
              return (

                <div key={plan.id}  className="card flex-item">

                  <div className="card-body">
                      <div className="large-price">{"$"+parseInt(plan.monthly_cost_cents)/100}<span> per month</span></div>
                  </div>
                  <div className="card-body">
                      <div className="feature">
                        <i className="material-icons">location_on</i>
                        <div className="feature-text">
                          <p>Unlimited property owner lookups and property info: owner name, owner’s mailing address, property sale date, calculated mortgage balance, and more.</p>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="feature">
                        <i className="material-icons">search</i>

                        <div className="feature-text">
                          <p>{"$"+parseFloat(plan.enhanced_search_price/100).toFixed(2)+" to look up the owner’s phone number and email address"}</p>
                        </div>
                      </div>
                    </div>
                      <div className="card-body">
                        <div className="feature">
                          <i className="material-icons">mail</i>
                          <div className="feature-text">
                            <p>{"$"+parseFloat(plan.additional_price/100).toFixed(2)+" per postcard"}</p>
                          </div>
                        </div>
                      </div>
                  </div>
              );
            })
          }
        </div>
      );
    }
  }

  render() {
    if(this.props.copy_tab == "pricing"){
      return (
        <div id="pricing" className="pricing-tab tab-container">


          <div style={{margin: 20, textAlign: "center"}}>
            <h2>Why take pictures for <b>{this.renderTeamName()}</b>?</h2>
          </div>

          <div className="card flex-item">
            <div className="card-body">
                <div className="feature">
                  <i className="material-icons">attach_money</i>
                  <div className="feature-text">
                    <h4>Earn good money!</h4>
                </div>
              </div>
            </div>
          <div className="card-body">
            <div className="feature">
              <i className="material-icons">account_balance</i>
                <div className="feature-text">
                  <h4>Payments made directly to you.</h4>
                </div>
              </div>
            </div>


          <div className="card-body">
            <div className="feature">
                <i className="material-icons">event</i>
                <div className="feature-text">
                  <h4>Set your own schedule and work only when it's convenient for you</h4>
                </div>
              </div>
          </div>

          <div className="card-body">
            <div className="feature">
              <i className="material-icons">home</i>
                <div className="feature-text">
                  <h4>Help {this.renderTeamName()} beautify and restore neighborhoods</h4>
                </div>
              </div>
          </div>
          <div className="card-body">
            <div className="feature">
              <i className="material-icons">schedule</i>
                <div className="feature-text">
                  <h4>Signing up takes just minutes!</h4>
                </div>
              </div>
          </div>



        </div>
        <div style={{margin: 20, marginBottom:60, textAlign: "center"}}>
            <h2>Start Earning Today</h2>
            <p><a href={'tel:'+this.props.team.phone}>{this.props.team.phone}</a></p>
            <p>This offer is provided by <b>{this.renderTeamName()}</b>, who will provide you with access to DealMachine, the mobile app you’ll use to take pictures. <b>{this.renderTeamName()}</b> will provide you with a partner contract, and will be the party responsible for paying you.</p>
          </div>
        </div>
      );
    }else{
      return <div />;
    }
  }
};

const mapStateToProps = ({ auth }) => {
  const { copy_tab, team, plans, plans_loading, plans_error, signup_type, signup_team_name, signup_team_company } = auth;
  return { copy_tab, team, plans, plans_loading, plans_error, signup_type, signup_team_name, signup_team_company }
}

export default withRouter(connect(mapStateToProps, {})(Pricing));



// WEBPACK FOOTER //
// ./src/components/GetStarted/Pricing.js